module.exports = {"TXTCLI_Play":{"id":"TXTCLI_Play","defaultMessage":"Spela","flags":["TRACK"],"track":"Play"}}